
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import UserTable from './users/UserTable';
import UserSearch from './users/UserSearch';
import InviteUserDialog from './users/InviteUserDialog';
import { useUsers } from './users/useUsers';

const UsersTab = () => {
  const {
    searchTerm,
    setSearchTerm,
    users,
    isLoading,
    showInviteDialog,
    setShowInviteDialog,
    handleSearch,
    handleRefresh,
    toggleAdminStatus,
    handleCreateInvite
  } = useUsers();

  return (
    <Card>
      <CardHeader>
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
          <div>
            <CardTitle>User Management</CardTitle>
            <CardDescription>
              View and manage user accounts and progress
            </CardDescription>
          </div>
          <div className="flex gap-2">
            <InviteUserDialog 
              isOpen={showInviteDialog}
              setIsOpen={setShowInviteDialog}
              isLoading={isLoading}
              handleCreateInvite={handleCreateInvite}
            />
            <Button 
              variant="outline" 
              size="sm" 
              onClick={handleRefresh}
              disabled={isLoading}
            >
              <RefreshCw className={`mr-1 h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
              Refresh
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <UserSearch 
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          handleSearch={handleSearch}
        />
        <UserTable 
          users={users}
          isLoading={isLoading}
          toggleAdminStatus={toggleAdminStatus}
        />
      </CardContent>
    </Card>
  );
};

export default UsersTab;
